import { render } from "./ToplogoImage.vue?vue&type=template&id=21e98507&scoped=true"
const script = {}

import "./ToplogoImage.vue?vue&type=style&index=0&id=21e98507&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e98507"]])

export default __exports__